export class ElectronicCommunicationMhs {
    hasElectronicCommunication: string;
    electronicCommunicationEmail?: string;
}